<template>
  <div class="attribute-change-items">
    <div
      class="attribute-change-item"
      :class="{ isRemoval }"
      v-for="(value, index) in values"
      :key="`${index}_value`"
    >
      <template v-if="isBool">
        <div v-if="value">
          <v-icon left>
            icon-check
          </v-icon>
          <p>{{ name }}</p>
        </div>
        <div v-else-if="value === false">
          <v-icon left>
            mdi-cancel
          </v-icon>
          <p>{{ name }}</p>
        </div>
        <div v-else>
          <v-icon left>
            icon-plus
          </v-icon>
          <p>{{ name }}</p>
        </div>
      </template>
      <template v-else-if="isEnum">
        <p>{{ getMetadataLabel(value) }}</p>
      </template>
      <template v-else-if="isRepeatedEnum">
        <div v-if="value.value">
          <v-icon left>
            icon-check
          </v-icon>
          <p>{{ getMetadataLabel(value.name) }}</p>
        </div>
        <div v-else-if="value.value === false">
          <v-icon left>
            mdi-cancel
          </v-icon>
          <p>{{ getMetadataLabel(value.name) }}</p>
        </div>
        <div v-else>
          <v-icon left>
            icon-plus
          </v-icon>
          <p>{{ getMetadataLabel(value.name) }}</p>
        </div>
      </template>
      <template v-else-if="isUrlAttribute">
        <div>
          <p>{{ value.url }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { GmbAttributeValueType } from "@/enums/gmb-attribute-value-type";
import { EXTERNAL_CHANGES_TYPE } from "@/enums/external-changes";

export default {
  name: "GmbAttributeChangeItem",
  props: {
    attribute: {
      type: Object
    },
    changeType: {
      type: Number,
      validate: value => Object.values(EXTERNAL_CHANGES_TYPE).includes(value)
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
    isCurrentLanguageDifferentThanPl() {
      return this.currentLanguage !== "pl";
    },
    valueType() {
      return (
        this.attribute &&
        this.attribute.gmb_attribute &&
        this.attribute.gmb_attribute.value_type
      );
    },
    name() {
      return (
        this.attribute &&
        this.attribute.gmb_attribute &&
        (this.isCurrentLanguageDifferentThanPl &&
        this.attribute.gmb_attribute.display_name_en
          ? this.attribute.gmb_attribute.display_name_en
          : this.attribute.gmb_attribute.display_name)
      );
    },
    values() {
      return this.attribute.values;
    },
    isBool() {
      return (
        (this.attribute &&
          this.attribute.gmb_attribute &&
          this.attribute.gmb_attribute.value_type &&
          this.attribute.gmb_attribute.value_type ===
            GmbAttributeValueType.BOOL) ||
        false
      );
    },
    isEnum() {
      return (
        (this.attribute &&
          this.attribute.gmb_attribute &&
          this.attribute.gmb_attribute.value_type &&
          this.attribute.gmb_attribute.value_type ===
            GmbAttributeValueType.ENUM) ||
        false
      );
    },
    isRepeatedEnum() {
      return (
        (this.attribute &&
          this.attribute.gmb_attribute &&
          this.attribute.gmb_attribute.value_type &&
          this.attribute.gmb_attribute.value_type ===
            GmbAttributeValueType.REPEATED_ENUM) ||
        false
      );
    },
    isUrlAttribute() {
      return (
        (this.attribute &&
          this.attribute.gmb_attribute &&
          this.attribute.gmb_attribute.value_type &&
          this.attribute.gmb_attribute.value_type ===
            GmbAttributeValueType.URL) ||
        false
      );
    },
    isRemoval() {
      return this.changeType === EXTERNAL_CHANGES_TYPE.REMOVAL;
    }
  },

  methods: {
    getMetadataLabel(value) {
      const metadataValues =
        this.attribute &&
        this.attribute.gmb_attribute &&
        this.attribute.gmb_attribute.value_metadata;

      if (metadataValues.length > 0) {
        const metadata = metadataValues.find(meta => meta.value === value);
        return (metadata && metadata.displayName) || value;
      }
      return value;
    }
  }
};
</script>

<style lang="scss" scoped>
.attribute-change-items {
  display: flex;
  flex-direction: column;
}

.attribute-change-item {
  position: relative;
  align-self: flex-start;

  & > div {
    display: flex;
  }

  p {
    line-height: 24px;
    margin-bottom: 0;
  }
}

.isRemoval {
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    top: 50%;
    background-color: #000;
  }
}
</style>
